export function validatePhoneNumber(phoneNumber?: string | null){
  const numberPattern = /^[0-9]+$/;
  if (!phoneNumber || !numberPattern.test(phoneNumber)) {
    return false
  }
  if (phoneNumber[0] === '0') {
    return phoneNumber?.length === 10
  }
  return phoneNumber?.length === 9
}